module.exports = __webpack_public_path__ + "static/media/ghostboard.0c48198c.png";